import { CloseIcon } from "@/domains/icons"
import { cn } from "@/domains/library"

const CloseDialogX = ({ onClick, className }: { onClick: () => void; className?: string }) => {
  return (
    <div
      className={cn(
        "cursor-pointer",
        "text-t200",
        "bg-p400 rounded-sm p-[2px] opacity-70 transition-opacity disabled:pointer-events-none",
        "ring-offset-p400-light",
        "hover:cursor-pointer hover:opacity-100",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-0",
        className,
      )}
      onClick={onClick}
    >
      <CloseIcon size={20} />
      <span className="sr-only">Close</span>
    </div>
  )
}

export default CloseDialogX
